import { createFilledIcon } from "~/components/ui/icon/createIcon";

export const MoreVerticalFilledIcon = createFilledIcon(
  <>
    <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
  </>,
  "MoreVerticalFilledIcon"
);
